import React from 'react';
import {
    Link
} from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar';
import {
    Container,
    Title,
    Description,
    Content,
    NewLine,
    Point
} from './style';

class About extends React.Component {
    state = {
        loadingBarProgress: Math.random() * 100
    };

    complete = () => {
        this.setState({ loadingBarProgress: 100 });
    };

    onLoaderFinished = () => {
        this.setState({ loadingBarProgress: 0 });
    };

    componentDidMount() {
        this.complete();
    }

    render() {
        return (
            <Container>
                <LoadingBar
                    progress={this.state.loadingBarProgress}
                    height={3}
                    color='#fff'
                    onLoaderFinished={() => this.onLoaderFinished()}
                />
                <Link to="/"><Title> {"{"} nightbot.dev {"}"} </Title></Link>
                <Description><Point> About Me </Point></Description>
                <Content>
                    Hi, I'm Diky Hadna. I develop chatbots and write tech articles on Medium.
                    <NewLine />
                    <NewLine />
                    <Point>Languages I usually use (but not limited to):</Point>
                    <NewLine />
                    Javascript (React &amp; NodeJS) &middot; Python
                    <NewLine />
                    <NewLine />
                    <Point>Things I'm interested at:</Point>
                    <NewLine />
                    Chatbots &middot; Natural Language Processing &middot; Data Science
                    <NewLine />
                    <NewLine />
                    Feel free to try the demo projects that I put in this site (that you can access through the homepage).
                    Also, there will be new interesting projects that I will add in the future, be sure to regularly visit this site.
                    <NewLine />
                    <NewLine />
                    If you have any question or just want to say hi, drop me a message: dikyhd ^gmail
                    <NewLine />
                    Or click the links on the bottom of the page
                </Content>
            </Container>
        )
    }
}

export default About;